import { getRelativeValue } from 'src/components/dashboard/DashboardPage/helper';
import type { AggregateList } from 'src/components/followUp/common/types';

export const extractNpsData = (data?: AggregateList) => {
  const npsData = {
    promoters:
      data?.results.find(({ label }) => label === 'Promoter')?.value ?? 0,
    passives:
      data?.results.find(({ label }) => label === 'Passive')?.value ?? 0,
    detractors:
      data?.results.find(({ label }) => label === 'Detractor')?.value ?? 0,
  };
  // We use the rounded percentage values for the calculation to prevent
  // users to be confused.
  // Example:
  // having 99 passives, 5 promoters (4,54% => 5% of 110) and 6 detractors
  // (5,45% => 5% of 110) will result in an NPS of 0 instead of an NPS of 1.
  const totalScore =
    getRelativeValue(npsData.promoters, data?.totalObjects, 0) -
    getRelativeValue(npsData.detractors, data?.totalObjects, 0);
  return { ...npsData, totalScore };
};
